import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import Image from '../../../Core/Image';
import Ctas from '../../../Core/Ctas';
import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - 80px);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - 120px);
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: 1.5rem;
  background-color: ${({ bgColor }) =>
    bgColor ? themeGet(`colors.${bgColor}`) : 'transparent'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    border-radius: 0.75rem;
    padding: 1.5rem 2rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    gap: 5.5rem;
    flex-direction: row;
  }
`;

export const Heading = styled.h2`
  font-size: 1.5rem;
  line-height: 150%;
  font-weight: ${themeGet('fontWeights.medium')};

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 2rem;
    line-height: 130%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;
  gap: 1.5rem;
  padding: 1.5rem 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: unset;
    width: 55%;
  }
`;

export const Body = styled.div`
  p {
    font-size: 1rem;
    line-height: 150%;
  }
`;

export const Img = styled(Image)`
  margin: auto;
  max-height: 30rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 31rem;
    border-radius: 0.5rem;
  }
`;

export const StyledCtas = styled(Ctas)`
  margin-top: 0;
`;
